import { render, staticRenderFns } from "./CuponDetails.vue?vue&type=template&id=734578a6&"
import script from "./CuponDetails.vue?vue&type=script&lang=js&"
export * from "./CuponDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports